import React from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './../../../Assets/Css/swiper.css'
import {Keyboard, Scrollbar, Navigation, Pagination, Autoplay} from 'swiper/modules';


function SliderCards(props) {

    return (
        <Swiper
            slidesPerView={2}
            spaceBetween={0}
            centeredSlides={false}
            slidesPerGroupSkip={1}
            grabCursor={false}
            keyboard={{
                enabled: true,
            }}
            breakpoints={{
                450: {
                    slidesPerView: 3,
                    // spaceBetween:30
                },
                640: {
                    slidesPerView: 4,
                    spaceBetween:20
                },
                769: {
                    slidesPerView: 5,
                    spaceBetween:20
                },
                1224: {
                    slidesPerView: 7,
                    spaceBetween:0
                },
            }}
            loop={true}
            direction={"horizontal"}
            freeMode={true}
            /*autoplay={{ delay: 3000, disableOnInteraction: false }}*/
            modules={[Keyboard, Scrollbar, Navigation, Pagination, Autoplay]}
            className={"!pl-16 sm:!pl-12 md:!pl-10 lg:!pl-16"}
        >

            {
                props.data?.map((item, index) =>
                    <SwiperSlide>
                        <div
                            className='flex flex-col space-y-1'>
                            <img src={item.image} alt='cover' className='w-[100px] h-[100px] lg:w-[100px] lg:h-[100px] xl:w-[120px] xl:h-[120px] rounded'/>
                            <div className="flex flex-row justify-between items-center">
                                <div className='flex flex-col text-xs'>
                                    <div className='font-medium font-medium mb-2'>{item.title}</div>
                                    <div className='text-gray-800'>{item.subTitle}</div>
                                </div>
                            </div>
                        </div>

                    </SwiperSlide>
                )
            }
        </Swiper>
    );
}

export default SliderCards;